module.exports = __webpack_public_path__ + "static/img/microba-insight-kit.bb8c0c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/microba-insight-kit.png
// module id = w3ss
// module chunks = 1